var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGarage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.334,48H2.666A2.669,2.669,0,0,1,0,45.334V16a2.657,2.657,0,0,1,1.255-2.261L22.586.4a2.67,2.67,0,0,1,2.827,0L46.747,13.737A2.656,2.656,0,0,1,48,16V45.334A2.669,2.669,0,0,1,45.334,48ZM10.668,21.333H37.334A2.669,2.669,0,0,1,40,24V42.667h2.666V17.476L24,5.81,5.335,17.476V42.667H8V24A2.669,2.669,0,0,1,10.668,21.333Zm2.666,16v5.335H34.668V37.332Zm0-10.666V32H34.668V26.666H13.334Z",
    transform: "translate(3 3)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGarage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/garage.a0a2bbeb.svg";
export { ForwardRef as ReactComponent };